module.exports = __webpack_public_path__ + "img/AZ.008a1cab.png";